import Vue from 'vue'
import UUID from 'uuid'

/**
 * 扩展unWatch属性（声明不需要被vue监听的对象）
 * 推荐
 */
Vue.mixin({
    beforeCreate: function() {
        const list = [this.$options]
        while (list.length) {
            const item = list.shift()
            if (item.unWatch) {
                Object.assign(this, item.unWatch.call(this))
            }
            if (item.mixins) {
                list.push(...item.mixins)
            }
        }
    }
})

/**
 * @deprecated
 * vue-plugin
 * 避免变量被vue监听（对象工厂模式）
 */
const ObjFactory = {
    install(vue, opt_options) {
        const ObjMap = new Map()

        /**
         * 保存对象
         * @returns {String} 对象Id
         */
        vue.prototype.add = function(obj) {
            const objId = UUID.v1()
            ObjMap.set(objId, obj)
            return objId
        }
        /**
         * 移除对象
         * @returns {String} 对象Id
         */
        vue.prototype.remove = function(objId) {
            const obj = ObjMap.get(objId)
            ObjMap.delete(objId)
            return obj
        }
        /**
         * 获取对象
         * @returns {String} 对象Id
         */
        vue.prototype.get = function(objId) {
            return ObjMap.get(objId) || null
        }
    }
}
